module.exports = __webpack_public_path__ + "img/597c9ae.svg";